export default {
  DEV: process.env.NODE_ENV === 'development',
};
